import { GridDefinition } from '.';
import { DryMassWorksheetGridDefinition } from './DryMassReadingWorksheetGrid';
import { MoistureContentWetMassWorksheetGridDefinition } from './MoistureContentWetMassWorksheetGrid';

export const WorksheetGridKeys = {
  DryMassEntry: 'dry-mass-entry',
  WetMassEntry: 'wet-mass-entry',
};

const WorksheetGridDefinitions: { [key: string]: GridDefinition } = {
  [WorksheetGridKeys.DryMassEntry]: DryMassWorksheetGridDefinition,
  [WorksheetGridKeys.WetMassEntry]: MoistureContentWetMassWorksheetGridDefinition,
};

export const getGridDefinition = (key: string) => WorksheetGridDefinitions[key];
